import { render } from "./FlowerClock2.vue?vue&type=template&id=4aa256e5&scoped=true"
import script from "./FlowerClock2.vue?vue&type=script&lang=js"
export * from "./FlowerClock2.vue?vue&type=script&lang=js"

import "./FlowerClock2.vue?vue&type=style&index=0&id=4aa256e5&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aa256e5"]])

export default __exports__